
export interface CustomIcon {
  name: string;
  path: string;
  variants?: {
    hover?: string;
    pressed?: string;
    [key: string]: string | undefined;
  };
}

export const CUSTOM_ICONS: CustomIcon[] =  [
  {
    name: 'task',
    path: 'assets/icons/task.svg',
  },
  {
    name: 'user-analytics',
    path: 'assets/icons/user-analytics.svg',
  },
  {
    name: 'book',
    path: 'assets/icons/book.svg',
  },
  {
    name: 'megaphone',
    path: 'assets/icons/megaphone.svg',
  },
  {
    name: 'arrow',
    path: 'assets/icons/arrow.svg',
  },
  {
    name: 'chevron-right',
    path: 'assets/icons/chevron-right.svg',
  },
  {
    name: 'chevron-left',
    path: 'assets/icons/chevron-left.svg',
  },
  {
     name: 'ranking-gold',
     path: 'assets/icons/ranking-gold.svg',
  },
  {
     name: 'ranking-silver',
     path: 'assets/icons/ranking-silver.svg',
  },
  {
     name: 'ranking-bronze',
     path: 'assets/icons/ranking-bronze.svg',
  },
  {
     name: 'question-circle',
     path: 'assets/icons/question-circle.svg',
  },
];
